import { defineComponent as _defineComponent } from 'vue'
import { ProvVisCreator } from '@visdesignlab/trrack-vis';
import { computed, onMounted, ref } from 'vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvVis',
  setup(__props) {

const provenance = computed(() => store.state.provenance);
const provDiv = ref();

onMounted(() => {
  if (provenance.value !== null && provDiv.value != null) {
    ProvVisCreator(
      provDiv.value,
      provenance.value,
      (newNode: string) => store.commit.goToProvenanceNode(newNode),
      true,
      true,
      provenance.value.root.id,
    );
  }
});

return { __sfc: true,provenance, provDiv, store }
}

})